module.exports = __webpack_public_path__ + "img/dead-tree-desert-08.be55a4cb.png";